import { TableNames } from "../../../enums/tableNames";
import { useModalOpener } from "../../../hooks/useModalOpener";
import { CallingWorklistView } from "../utils/buildWorklistFilters";
import CallingWorklistTable from "./callingWorklistTable";

interface WorklistPageProps {
  /** Page heading above the table. */
  heading: string;
  /** Worklist to fetch; decides the filters sent with every request. */
  view: CallingWorklistView;
  /** Table the page owns filter, search and pagination state under. */
  tableName: TableNames;
}

/**
 * Shared page shell for the outreach worklists. The non-ePA and Pending pages
 * render the same table and modals and differ only in the fetch filters.
 *
 * @param props.heading - Page heading
 * @param props.view - Worklist to fetch
 * @param props.tableName - Table state key for this page
 */
const WorklistPage = (props: WorklistPageProps) => {
  useModalOpener();

  return (
    <div className="calling_worklist__layout h-full w-full bg-primaryGray-16 p-2">
      <div className="calling_worklist__inner-container flex h-full flex-col gap-2 overflow-hidden rounded bg-white p-4">
        <div className="calling_worklist__heading text-h11 font-bold">
          {props.heading}
        </div>
        <div className="calling_worklist__table-container flex-1 overflow-auto">
          <CallingWorklistTable view={props.view} tableName={props.tableName} />
        </div>
      </div>
    </div>
  );
};

export default WorklistPage;
